import useSWR from 'swr';
import { useClientVD } from '../../hooks/useClientVD';
import { honoFetcher } from '../../lib/honoFetcher';

export function useDatasets() {
  const client = useClientVD();

  const { data = [], mutate } = useSWR(
    'datasets',
    async () => {
      const result = await honoFetcher(client.datasets.$get());
      return result ?? [];
    },
    {
      suspense: true,
      revalidateOnFocus: false,
    },
  );

  return { datasets: data, mutate };
}
